module.exports = __webpack_public_path__ + "static/media/11_MEDS-1.9-EQ-14 2.64da2c12.png";